import { useEffect, useState } from "react";
import { useParams, Redirect, useHistory } from "react-router-dom";
import axios from "axios";
import Home from "./Home";
import { HEARTIST_GEOLOCATION } from "../../constants";

/** en - for the rest of the world */
const HEARTIST_COUNTRIES = ["au","in","id","my","nz","ph","sg","th","vn", "en"];

export default function HeartistRoute() {
    const { country } = useParams();
    const history = useHistory();
    const [effectiveCountry, setEffectiveCountry] = useState(country?.toLowerCase() || "au");

    useEffect(() => {
        const getGeolocation = async () => {
            try {
                const response = await axios.get(HEARTIST_GEOLOCATION);
                console.log("Geolocation response:", response.data);
                const { url, country: geoCountry } = response.data || {};
                const normalizedGeoCountry = geoCountry?.toLowerCase();

                // if country is not supported, redirect to /en/heartist
                if (!normalizedGeoCountry || !HEARTIST_COUNTRIES.includes(normalizedGeoCountry)) {
                    setEffectiveCountry("en");
                    history.replace("/en/heartist");
                    return;
                }

                // update state if different
                if (normalizedGeoCountry !== effectiveCountry) {
                    setEffectiveCountry(normalizedGeoCountry);
                }

                // update URL if different
                if (url && url !== window.location.pathname) {
                    history.replace(url);
                }
            } catch (error) {
                console.error("Geolocation API error:", error);
            }
        };

        getGeolocation();
    }, [history, effectiveCountry]);

    if (!HEARTIST_COUNTRIES.includes(effectiveCountry)) {
        return <Redirect to="/en/heartist" />;
    }

    return <Home country={effectiveCountry.toUpperCase()} />;
}